import { State } from 'reducers';
import { createSelector } from 'reselect';
import { getDeviceId } from './buildingsSelectors';

const getThemeHistoryState =
    (state: State) =>
        state.themeHistory;

export const getDeviceThemeHistory =
    createSelector(
        getThemeHistoryState,
        getDeviceId,
        (state, deviceId) => (state && deviceId && state.data[deviceId]) || null
    );

export const getDeviceThemeHistoryLoading =
    createSelector(
        getThemeHistoryState,
        getDeviceId,
        (state, deviceId) => !!(state && deviceId && state.loading[deviceId])
    );

export const getDeviceThemeHistoryError =
    createSelector(
        getThemeHistoryState,
        getDeviceId,
        (state, deviceId) => (state && deviceId && state.errors[deviceId]) || null
    );
